export const endpoints = {
  login: {
    mobile: 'api/login',        // WSAUTH01
    registration: 'api/register',
  },
  fiches: {
    list: 'api/fiches',
    download: 'api/fiche/download'
  },
  changelog: {
    list: 'api/changelog'
  },
  documents: {
    upload: 'api/document/upload',
    download: 'api/document/download'
  },
  groupes: {
    search: 'api/groupe/search',
    batiments: 'api/groupe/batiments',
    escaliers: 'api/groupe/escaliers',
  },
  natures: {
    list: 'api/natures',
    export_natures: 'api/natures.csv',
    import_natures: 'api/natures/import',
  },
  victimes: {
    list: 'api/victimes',
  },
  interventions: {
    list: 'api/interventions',
  },
  actions: {
    list: 'api/actions',
  },
  incivilites: {
    me: 'api/mes-declarations',
    my_colabs: 'api/declarations-de-mes-collabs',
    create: 'api/create',
    edit: 'api/edit',
    validate: 'api/validate',
    add_comment: 'api/add-comment',
    add_echange: 'api/add-echange',
    add_or_edit_retour: 'api/add-or-edit-retour',
    export: 'api/incivilite.csv',
    export_by_year: 'api/incivilite/export',
    export_repartition: 'api/repartition.csv',
    export_visu: 'api/visu.csv',
    export_retours: 'api/actions.csv',
    export_nature_fiche: 'api/nature-fiche.csv',
    export_assermentation: 'api/assermentations/export',
    import_actions: 'api/actions/import',
    import_nature_fiche: 'api/nature-fiche/import',
    import_visu: 'api/visu/import',
    import_notifications: 'api/repartition/import',
    import_assermentation: 'api/assermentations/import',
    declaration: 'api/declaration',
    export_pdf: 'api/declaration/export-pdf'
  },
  retours: {
    delete: 'api/retour',
  },
  typeRetours: {
    list: 'api/type-retours',
  },
  charts: {
    total: 'api/total',
    nature_par_type_nature: 'api/nature-par-type-nature',
    incivilites_par_mois: 'api/incivilites-par-mois',
    incivilites_par_groupe: 'api/incivilites-par-groupe',
    export_tuile_nombre_par_mois: 'api/incivilites-par-mois/export',
    export_tuile_top_10_groupes: 'api/incivilites-par-groupe/export',
    export_tuile_nature_par_type_nature: 'api/nature-par-type-nature/export',
    export_pdf_tuile_nature_par_type_nature: 'api/nature-par-type-nature/export-pdf',
    getPatrimoineFilters: 'api/patrimoine-filters',
  },
  importParametragesHisto: {
    list: 'api/import-histo',
    download: 'api/import-histo/download',
  },
  api_rivp: {
    patrimoine: {
      search_locataires: '?route=lukla/patrimoine/searchLocataires',
    }
  }
};


